import { REQUEST_PROFILE_HEADER_FOOTER_ACTION } from '../../RequestProfileHeaderFooter.constants'
import { useRequestProfileCreateActivityAction } from '../useRequestProfileCreateActivityAction'
import { useRequestProfileCreateDocFlowAction } from '../useRequestProfileCreateDocFlowAction'
import { useRequestProfileCreateEmailAction } from '../useRequestProfileCreateEmailAction'
import { useRequestProfileCreateFolderAction } from '../useRequestProfileCreateFolderAction'
import { useRequestProfileCreateInvoiceAction } from '../useRequestProfileCreateInvoiceAction'
import { useRequestProfileCreatePostAction } from '../useRequestProfileCreatePostAction'
import { useRequestProfileCreateServiceRequestAction } from '../useRequestProfileCreateServiceRequestAction'
import { useRequestProfileUploadFileAction } from '../useRequestProfileUploadFileAction'

export function useRequestProfileHeaderFooterActions() {
  const { handleClickCreateActivity } = useRequestProfileCreateActivityAction()

  const { handleClickCreateEmail, handleSelectEmailAudience } =
    useRequestProfileCreateEmailAction()

  const { getUploadFileInputProps, handleClickUploadFile } =
    useRequestProfileUploadFileAction()

  const { handleClickCreateFolder } = useRequestProfileCreateFolderAction()

  const { handleClickCreateInvoice } = useRequestProfileCreateInvoiceAction()

  const { handleClickCreatePost } = useRequestProfileCreatePostAction()

  const { handleClickCreateServiceRequest } =
    useRequestProfileCreateServiceRequestAction()

  const { handleClickCreateDocFlow, handleSelectDocFlowOption } =
    useRequestProfileCreateDocFlowAction()

  const actionHandlers = {
    [REQUEST_PROFILE_HEADER_FOOTER_ACTION.activity]: handleClickCreateActivity,
    [REQUEST_PROFILE_HEADER_FOOTER_ACTION.docFlow]: handleClickCreateDocFlow,
    [REQUEST_PROFILE_HEADER_FOOTER_ACTION.email]: handleClickCreateEmail,
    [REQUEST_PROFILE_HEADER_FOOTER_ACTION.folder]: handleClickCreateFolder,
    [REQUEST_PROFILE_HEADER_FOOTER_ACTION.invoice]: handleClickCreateInvoice,
    [REQUEST_PROFILE_HEADER_FOOTER_ACTION.post]: handleClickCreatePost,
    [REQUEST_PROFILE_HEADER_FOOTER_ACTION.serviceRequest]:
      handleClickCreateServiceRequest,
    [REQUEST_PROFILE_HEADER_FOOTER_ACTION.upload]: handleClickUploadFile,
  }

  const selectHandlers = {
    [REQUEST_PROFILE_HEADER_FOOTER_ACTION.docFlow]: handleSelectDocFlowOption,
    [REQUEST_PROFILE_HEADER_FOOTER_ACTION.email]: handleSelectEmailAudience,
  }

  return {
    actionHandlers,
    getUploadFileInputProps,
    selectHandlers,
  }
}
